import { ssoStatusResponseSchema } from '@gb-ticket/shared-types';
import { useQuery } from '@tanstack/react-query';

import { apiFetch } from '@/lib/api';

export const ssoStatusQueryKey = ['auth', 'sso-status'] as const;

export function useSsoStatus() {
  return useQuery({
    queryKey: ssoStatusQueryKey,
    queryFn: () => apiFetch('/auth/sso-status', ssoStatusResponseSchema),
    retry: false,
    staleTime: 5 * 60 * 1000,
  });
}
